

























































import { Component, Vue } from "vue-property-decorator";
import DadosTelefone from "@/components/dados/DadosTelefone.vue";
import DadosDdd from "@/components/dados/DadosDdd.vue";
import DadosEmail from "@/components/dados/DadosEmail.vue";
import DadosProsseguir from "@/components/dados/DadosProsseguir.vue";
import DadosCpf from "@/components/dados/DadosCpf.vue";
import { mask } from 'vue-the-mask';
import axios from 'axios';
import { directives } from 'vuetify/lib';

@Component({
    components: {
        DadosTelefone,
        DadosEmail,
        DadosProsseguir,
        DadosCpf,
        DadosDdd
    },
    directives: {
      mask
    }
})
export default class Complemento extends Vue {

    public cpfMask = "###.###.###-##";
    public email = "";
    public cpf = "";

    get nome () {
        return this.$store.state.cotacao.nome;
    }

    set nome ( value ) {
        this.$store.commit("SET_NOME", value);
    }

    get errorNome () {
        return this.$store.state.errors.nome;
    }

    public onChange () {
        this.$store.dispatch("VALIDAR_DADOS")
            .then()
            .catch(() => { return; });
    }



    public mounted () {
        this.$store.commit('SET_SIDEBAR_SHOWING', false);
        this.$store.commit('SET_SIDEBAR_ENABLED', false);

        const query = this.$route.query as {ref: string, fipe: string, ano: string};
        if ( query.fipe !== undefined && query.ano !== undefined ) {
            this.$store.dispatch('FROM_COD_ANO', query).then();
        }
    }

    get origemFipe () {
        return this.$store.state.origem_fipe;
    }

    public onClick() {
        this.$router.push({
            name: 'complemento'
        }); 
    }
    

}
